import Data from '../../../../components/Display/Data';
import { Button } from 'primereact/button';
import MultiLineData from '../../../../components/Display/MultiLineData';
import MultipleDataTag from '../../../../components/Display/MultipleDataTag';
import styles from "../../cards.module.scss"


function ReviewListItem({ review, deleteReview, updateReview, layout }) {
  return (
    <div className={`${styles.reviewCard} ${layout === "grid" ? styles.reviewCardGrid : ''}`}>
      <div className={styles.content}>
        <div className={styles.top}>
          <Data key="author" label={'Auteur'} value={review.author} large />
          <Data key="company" label={"Nom de l'entreprise"} value={review.company} large />
        </div>

        <MultipleDataTag key="properties" label={'Métier.s'} tags={review.properties} />

        <MultiLineData
          key="description"
          label={'Description'}
          value={review.content}
          large
          asHtml
        />
      </div>
      <div className={styles.buttonList}>
        <Button
          rounded
          icon="pi pi-pencil"
          severity="success"
          onClick={() => updateReview(review)}
          outlined
          size="small"
          className={styles.button}
        />
        <Button
          rounded
          icon="pi pi-trash"
          severity="danger"
          onClick={() => deleteReview(review)}
          outlined
          size="small"
          className={styles.button}
        />
      </div>
    </div>
  );
}

export default ReviewListItem;
